import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createDivision, getAllDivisions, updateDivision } from "../../api/divisions/divisionsApi";
import { Division, Divisions } from "../../api/divisions/types";




export const useAllDivisionData = () => {
     return useQuery<Divisions>({
          queryKey: ["allDivisions"],
          queryFn: () => getAllDivisions({ filter: `status=true` }),
          staleTime: 1000 * 60 * 15, // 15 minutes
          gcTime: 1000 * 60 * 15, // 15 minutes
     });
};


export const useCreateDivision = () => {
     const queryClient = useQueryClient();
     return useMutation<Division, Error, Division>({
          mutationFn: (division) => createDivision(division),
          onSuccess: () => {
               queryClient.invalidateQueries({ queryKey: ["allDivisions"] });
          },
          onError: (error) => {
               console.error("Error creating division:", error);
          },
     });
};

export const useUpdateDivision = () => {
     const queryClient = useQueryClient();
     return useMutation<Division, Error, Division>({
          mutationFn: (division) => updateDivision(division),
          onSuccess: () => {
               queryClient.invalidateQueries({ queryKey: ["allDivisions"] });
          },
          onError: (error) => {
               console.error("Error updating division:", error);
          },
     });
};
